import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import advancedSearchReducer from "./reducers/advancedSearchReducer";
import announcementsReducer from "./reducers/announcementsReducer";
import answerReducer from "./reducers/answerReducer";
import commentsReducer from "./reducers/commentsReducer";
import coursesReducer from "./reducers/coursesReducer";
import currentTopicAndQuizReducer from "./reducers/currentTopicAndQuizReducer";
import headerReducer from "./reducers/headerReducer";
import leadershipBoardReducer from "./reducers/leadershipBoardReducer";
import liveCoursesReducer from "./reducers/liveCoursesReducer";
import myActivityReducer from "./reducers/myActivityReducer";
import quizListReducer from "./reducers/quizListReducer";
import quizQuestionsReducer from "./reducers/quizQuestionsReducer";
import quizStateReducer from "./reducers/quizStateReducer";
import quizzesReducer from "./reducers/quizzesReducer";
import searchReducer from "./reducers/searchReducer";
import selectCourseReducer from "./reducers/selectCourseReducer";
import selectQuizReducer from "./reducers/selectQuizReducer";
import statisticsReducer from "./reducers/statisticsReducer";
import topicStartReducer from "./reducers/topicStartReducer";
import profileReducer from './slices/profile';
const rootReducer = combineReducers({
    coursesState: coursesReducer,
    selectedCourse: selectCourseReducer,
    quizzesState: quizzesReducer,
    selectedQuiz: selectQuizReducer,
    quizQuestionsState: quizQuestionsReducer,
    headerState: headerReducer,
    quizProgressState: quizStateReducer,
    answerState: answerReducer,
    profile: profileReducer,
    leadershipBoardState: leadershipBoardReducer,
    statisticsState: statisticsReducer,
    announcementsState: announcementsReducer,
    quizListState: quizListReducer,
    currentTopicAndQuizState: currentTopicAndQuizReducer,
    myActivityState: myActivityReducer,
    liveCoursesState: liveCoursesReducer,
    topicStartState: topicStartReducer,
    commentsState: commentsReducer,
    searchState: searchReducer,
    advancedSearchState: advancedSearchReducer,
});

export const store = createStore(rootReducer, applyMiddleware(thunk))